// src/components/NotFound.tsx
import React from "react";
import { Box, Button, Typography, Container } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import SearchOffIcon from "@mui/icons-material/SearchOff";

const NotFound: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ textAlign: "center", py: 8 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mb: 4,
        }}
      >
        <SearchOffIcon sx={{ fontSize: 100, color: "text.secondary" }} />
      </Box>
      <Typography variant="h2" gutterBottom>
        404
      </Typography>
      <Typography variant="h4" gutterBottom>
        Page Not Found
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        The page you are looking for doesn't exist or has been moved.
      </Typography>
      <Button
        variant="contained"
        component={RouterLink}
        to="/"
        size="large"
        sx={{ mt: 2 }}
      >
        Back to Dashboard
      </Button>
    </Container>
  );
};

export default NotFound;
